import { Route, useNavigate } from 'react-router-dom'

import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard'

import Bypass from './Bypass'
import Card from './Card/Card'
import ActionRemove from './Card/ActionRemove'
import FormGlobal, { FormActivate } from './Forms'

const FormActivateContainer = () => {
  const navigate = useNavigate()
  return <FormActivate onClose={() => navigate('..')} onSuccess={() => navigate('..')} />
}

export const BypassRoutes = () => [
  <Route path='/bypass' element={
    <RouteGuard requiredRoles={['bypass']}>
      <Bypass />
    </RouteGuard>
  } key={'bypass'}>
    <Route path={'new'} element={<FormGlobal />} />
    <Route path=':id' element={<Card />}>
      <Route path={'remove'} element={<ActionRemove />} />
      <Route path={'edit'} element={<FormGlobal />} />
      <Route path={'activate'} element={<FormActivateContainer />} />
    </Route>
  </Route>
]

export default BypassRoutes
